/* global System */
// register component(s) with react habitat

export default { Interviews: () => System.import('./Component') }
